import { gql } from '@apollo/client';

export * from './updatePaymentMethod.mutation.generated';

export const UPDATE_PAYMENT_METHOD = gql`
  mutation updatePaymentMethod($clientMutationId: String) {
    updatePaymentMethod(input: { clientMutationId: $clientMutationId }) {
      success
      errors
      url
    }
  }
`;
